import { render, staticRenderFns } from "./product-warehouses-dialog.vue?vue&type=template&id=b3dc37e0&"
import script from "./product-warehouses-dialog.vue?vue&type=script&lang=js&"
export * from "./product-warehouses-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports